/** Maps API `alarmType` (domain enum int) to `common:alarmTypes.*` translation keys. */
export function alarmTypeLabel(alarmType, t) {
    switch (alarmType) {
        case 1:
            return t("common:alarmTypes.lowTemperature");
        case 2:
            return t("common:alarmTypes.highTemperature");
        case 3:
            return t("common:alarmTypes.fatReplacement");
        case 4:
            return t("common:alarmTypes.openDoor");
        case 5:
            return t("common:alarmTypes.noNodeCommunication");
        case 6:
            return t("common:alarmTypes.noApCommunication");
        case 7:
            return t("common:alarmTypes.temperatureReadingDelay");
        default:
            return t("common:alarmTypes.unknown");
    }
}
